import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { callTk } from 'api';
import type { FollowUnfollowParameters } from 'store/followUnfollow/followUnfollowSlice';
import { setFollowed, setUnfollowed } from 'store/followUnfollow/followUnfollowSlice';
import type { CompetitionType } from 'types/competition';

const FOLLOWABLE_TYPE = 'competition';

export const fetchCompetition = createAsyncThunk<CompetitionType | null, string | undefined>(
  'competitions/fetchCompetition',
  async (id, { rejectWithValue }) => {
    if (id) {
      const response = await callTk<CompetitionType>(
        `competitions/${id}`,
        { method: 'GET' },
        (error) => rejectWithValue(error),
        true,
      );
      return response;
    }
    return null;
  },
);

export const competitionSlice = createSlice({
  name: 'competition',
  initialState: {
    error: false,
    loading: false,
    competition: null as CompetitionType | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCompetition.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(fetchCompetition.fulfilled, (state, action: PayloadAction<CompetitionType | null>) => {
      state.loading = false;
      state.competition = action.payload;
    });
    builder.addCase(fetchCompetition.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(setFollowed, (state, action: PayloadAction<FollowUnfollowParameters>) => {
      const { id, type } = action.payload;
      if (type === FOLLOWABLE_TYPE && state.competition && state.competition.id === id) {
        state.competition.followed = true;
      }
    });
    builder.addCase(setUnfollowed, (state, action: PayloadAction<FollowUnfollowParameters>) => {
      const { id, type } = action.payload;
      if (type === FOLLOWABLE_TYPE && state.competition && state.competition.id === id) {
        state.competition.followed = false;
      }
    });
  },
});

export const competitionReducer = competitionSlice.reducer;
